import OverlappingPlannedBreaks from "components/pages/schedule/helpers/OverlappingPlannedBreaks";
import DateTime from "utils/DateTime";
import Timespan from "utils/Timespan";

const DowntimeBlock = {
  build,
  reasonDescription,
  updateBlock,
  updateOverlappingPlannedBreaks,
  validate,
};

function updateOverlappingPlannedBreaks(downtimeBlock) {
  const newDowntimeBlock = { ...downtimeBlock };

  const isInProgressOrFuture = DateTime.isInTheFuture(newDowntimeBlock.endsAt);
  if (isInProgressOrFuture) {
    newDowntimeBlock.overlappingPlannedBreaks = overlappingPlannedBreaks(newDowntimeBlock);
  }

  return newDowntimeBlock;
}

function build({ line, startsAt, endsAt, reason, reasonCode }) {
  return updateOverlappingPlannedBreaks({
    __typename: "DowntimeBlock",
    endsAt,
    line,
    lockedOnSchedule: false,
    overlappingPlannedBreaks: [],
    reason,
    reasonCode,
    startsAt,
  });
}

function updateBlock(downtimeBlock, { startsAt, endsAt }) {
  return updateOverlappingPlannedBreaks({
    ...downtimeBlock,
    endsAt,
    startsAt,
  });
}

function overlappingPlannedBreaks(downtimeBlock) {
  const breaks = new OverlappingPlannedBreaks({
    line: downtimeBlock.line,
  });

  const downtimeBlockTimespan = new Timespan(new Date(downtimeBlock.startsAt), new Date(downtimeBlock.endsAt));

  return breaks.getCombinedOverlappingPlannedBreaks(downtimeBlockTimespan);
}

function reasonDescription({ reason, reasonCode }) {
  if (reasonCode) {
    return `${reason} • ${reasonCode}`;
  }
  return reason;
}

function validate(data, downtimeReasonsCount) {
  const errors = {};

  if (new Date(data.startsAt) >= new Date(data.endsAt)) {
    errors.startsAt = "Start time must be before end time";
    errors.endsAt = "End time must be after start time";
  }

  if (downtimeReasonsCount === 0) {
    if (!data.reason && !data.reasonCode) {
      errors.reason = "Reason is required";
    }
  } else if (data.reasonCode === undefined && !data.reason) {
    errors.reasonCode = "Reason is required";
  } else if (!data.reason && !data.reasonCode) {
    errors.reason = "Reason is required";
  }

  return errors;
}

export default DowntimeBlock;
